import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import { useNavigate } from 'react-router-dom';
import {
    AiFillGitlab,
    AiFillLinkedin,
} from "react-icons/ai";


function Home2() {

    const navigate = useNavigate();
    function goToProject() {
        navigate("/project");
    }

    return (
        <Container fluid className="home-about-section" id="about">
            <Container>
                <Row>
                    <Col md={8} className="home-about-description">
                        <h1 style={{ fontSize: "2.6em" }}>
                            LET ME <span className="purple"> INTRODUCE </span> MYSELF
                        </h1>
                        <p className="home-about-body">
                            I’m Md Al-Mahmud, a Senior Software Engineer with over 7 years of experience in <span className="purple">Fintech</span>, HRM, Accounting, and E-Commerce projects. I specialize in .NET Core, PHP/Laravel, and modern JavaScript frameworks like Vue and React.
                            <br />
                            <br />
                            <br />
                            I’ve led development teams, worked on large-scale international money transfer systems integrating providers like <a target="_blank" href="https://www.thunes.com">Thunes, </a> <a target="_blank" href="https://www.mastercard.com/us/en.html">Mastercard,</a> and <a target="_blank" href="https://payall.com/">Payall,</a> and delivered high-performance applications using <span className="purple">Clean architecture, DDD, Design patterns ( Singleton, Factory, Repository ), Redis, and RabbitMQ.</span>
                            <br />
                            <br />
                            I’m passionate about building efficient, secure, and scalable solutions, and I enjoy solving complex problems—whether it’s <span className="purple">optimizing database queries</span>, improving system performance, or guiding junior developers.
                            <br />
                            <br />
                            I am currently employed as a Senior software Engineer at <a target="_blank" href="https://softrobotics.com.bd/" className="purple">Softrobotics bangladesh</a>
                            <br />
                            <br />
                            My Codecanyon :  <a target="_blank" className="purple" href="https://codecanyon.net/user/mamun2074/portfolio">Url</a>
                            <br />
                            Project : <a className="purple" href="#" onClick={goToProject}>Url</a>
                            <br />
                        </p>
                    </Col>
                    <Col md={4} className="myAvtar">
                        <Tilt>
                            <img src={myImg} className="img-fluid" alt="avatar" />
                        </Tilt>
                    </Col>
                </Row>
                <Row>
                    <Col md={12} className="home-about-social">
                        <h1>FIND ME ON</h1>
                        <p>
                            Feel free to <span className="purple">connect </span>with me
                        </p>
                        <ul className="home-about-social-links">
                            <li className="social-icons">
                                <a
                                    href="https://www.linkedin.com/in/mahmud2074/"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="icon-colour  home-social-icons"
                                >
                                    <AiFillLinkedin />

                                </a>
                            </li>
                        </ul>
                    </Col>
                </Row>
            </Container>
        </Container>
    );
}
export default Home2;
